import { useMutation } from "@tanstack/react-query";
import { toast } from "sonner";
import axiosAuth from "../../../axiosAuth";
import {
  SCHOOL_INSTALLMENTS_PDC,
  SCHOOL_INSTALLMENTS_PDC_BY_FINANCE,
  SCHOOL_INSTALLMENTS_PDC_BY_SALES,
} from "../../apiRoutes";
import { useSelector } from "react-redux";
import { RootState } from "@/redux/store";
import { removeEmptyFields } from "@/lib/utils";

export interface UpdatePdcPayload {
  installmentId: string;
  pdcId?: string; // For edit operations
  pdcYear: string;
  pdcNumber: string;
  pdcAmount: number;
  pdcDate: string;
  pdcStatus: string;
  pdcAmountReceived?: number;
  pdcClearedDate?: string;
  pdcRemarks?: string;
}

export interface UpdatePdcResponse {
  data?: unknown;
  message?: string;
  success?: boolean;
}

export const useUpdatePdcMutationFinance = (options?: {
  onSuccess?: () => void;
}) => {
   const loggedInUserData = useSelector(
        (state: RootState) => state.currentData.loggedInUserData
      );
  return useMutation({
    mutationFn: async (payload: UpdatePdcPayload) => {
      const { installmentId, pdcId, ...pdcData } = payload;
      const body = {
        ...pdcData
      };
     
      // If pdcId is provided, it's an update operation
      if (pdcId) {
        const response = await axiosAuth.put(
          `${SCHOOL_INSTALLMENTS_PDC}detail/`,
          { ...body, pdcId }
        );
        return response.data;
      } else {
        // Create new PDC
        console.log("loggedInUserData", removeEmptyFields(payload));
        const api =
          loggedInUserData.role === "SALES_OPS"
            ? SCHOOL_INSTALLMENTS_PDC_BY_SALES
            : SCHOOL_INSTALLMENTS_PDC_BY_FINANCE;
        const response = await axiosAuth.post(
          `${api}`,
          removeEmptyFields(payload)
        );
        return response.data;
      }
    },
    onSuccess: () => {
      toast.success("PDC details saved successfully");
      options?.onSuccess?.();
    },
    onError: (error: any) => {
      const message =
        error?.response?.data?.issues?.message ||
        error?.response?.data?.issues?.error ||
        error?.response?.data?.message ||
        "Failed to save PDC details";
      toast.error(message);
    },
  });
};
